import MailingListJson, { validateMailingListJson } from "./MailingListJson";
import { MailingRecipientStatus } from "./MailingRecipientStatus";
import { Validation } from "./Validation";

/**
 * Empfänger einer Mailingaussendung.
 */
export default interface MailingRecipientJson {
    ID: number | null;

    /**
     * Double-Opt-In Status des Empfängers.
     */
    state: MailingRecipientStatus,

    /**
     * Registrierungszeitpunkt des Empfängers.
     */
    registrationDate: string;

    /**
     * Liste an Namen von Mailinglisten zu der dieser Empfänger gehört.
     */
    mailingLists: MailingListJson[] | null;

    /**
     * Falls ein Member verlinkt ist: ID des Member:
     */
    //linkedMemberId: number | null;
}

export type MailingRecipientCustomerInfoJson = Pick<MailingRecipientJson, "state">;

export function defaultMailingRecipientJson(): MailingRecipientJson {
    return {
        ID: null,
        state: MailingRecipientStatus.confirmationPending,
        registrationDate: new Date().toISOString(),
        mailingLists: null
    };
}

export function validateMailingRecipientJson(item: MailingRecipientJson) {
    return new Validation(item)
        .validateInteger("ID", 0, null, true)
        .validateDate("registrationDate")
        .validateAllUsingFunction("mailingLists", validateMailingListJson, 0, true)
        .finish();
}

export function validateMailingRecipientJsonRequestForm(item: MailingRecipientJson) {
    return new Validation(item)
        .validateEquals("ID", null)
        .validateDate("registrationDate")
        .validateAllUsingFunction("mailingLists", validateMailingListJson, 0, true)
        .finish();
}

export function validateMailingRecipientJsonAdd(item: MailingRecipientJson) {
    return new Validation(item)
        .validateEquals("ID", null)
        .validateDate("registrationDate")
        .validateAllUsingFunction("mailingLists", validateMailingListJson, 0, true)
        .finish();
}